module.exports = __webpack_public_path__ + "static/media/mobile-image-dca.3e3100a5.png";